var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { HStack, Link, useRecipe } from "@chakra-ui/react";
import { faFacebook, faFlipboard, faInstagram, faLinkedinIn, faSquareYoutube, faThreads, faXTwitter, faBluesky, } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { getLinksForAnchors } from "@/components/utils";
var socialIcons = {
    Twitter: (_jsx(FontAwesomeIcon, { icon: faXTwitter, title: "X (Formerly: Twitter)", titleId: "x-title-id" })),
    Threads: (_jsx(FontAwesomeIcon, { icon: faThreads, title: "Threads", titleId: "threads-title-id" })),
    Linkedin: (_jsx(FontAwesomeIcon, { icon: faLinkedinIn, title: "LinkedIn", titleId: "linkedin-title-id" })),
    Youtube: (_jsx(FontAwesomeIcon, { icon: faSquareYoutube, title: "YouTube", titleId: "youtube-title-id" })),
    Facebook: (_jsx(FontAwesomeIcon, { icon: faFacebook, title: "Facebook", titleId: "facebook-title-id" })),
    Instagram: (_jsx(FontAwesomeIcon, { icon: faInstagram, title: "Instagram", titleId: "instagram-title-id" })),
    FlipBoard: (_jsx(FontAwesomeIcon, { icon: faFlipboard, title: "FlipBoard", titleId: "flipboard-title-id" })),
    BlueSky: (_jsx(FontAwesomeIcon, { icon: faBluesky, title: "BlueSky", titleId: "bluesky-title-id" })),
};
export var SocialLinks = function () {
    var _a, _b, _c, _d;
    var anchors = Object.keys(socialIcons);
    var properties = useContext(GlobalContext).properties;
    var socialLinks = getLinksForAnchors(anchors, properties);
    var recipe = useRecipe({ key: "SocialLinks" });
    var styles = (_a = recipe()["@layer recipes"]) !== null && _a !== void 0 ? _a : {};
    // WARNING: this is not a Chakra component, use canonical css property names
    var nonChakraStyles = {
        width: (_b = styles.width) === null || _b === void 0 ? void 0 : _b.toString(),
        height: (_c = styles.height) === null || _c === void 0 ? void 0 : _c.toString(),
        paddingLeft: (_d = styles.paddingLeft) === null || _d === void 0 ? void 0 : _d.toString(),
    };
    var items = anchors
        .filter(function (anchor) {
        return socialLinks.get(anchor) !== undefined;
    })
        .map(function (anchor) {
        var _a;
        var icon = React.cloneElement(socialIcons[anchor], {
            style: nonChakraStyles,
            opacity: 1,
        });
        return (_jsx(Link, __assign({ variant: "social", href: (_a = socialLinks.get(anchor)) === null || _a === void 0 ? void 0 : _a.href }, { children: icon }), anchor));
    });
    return _jsx(HStack, { children: items });
};
